












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class VisitsVisitorsTimeCharts extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {
    backgroundColor: 'transparent',
    chartArea: { left: '200', top: '0', right: '20', bottom: '50' },
    legend: { position: 'bottom' },
    isStacked: false,
    colors: ['102D69'],
    fontSize: 12,
    hAxis: {
      minValue: 0
    }
  };

  mounted() {
    this.load();
  }

  load() {
    this.chartData = [];
    this.chartData.push(['Usuário', 'Tempo em visitas (horas)', { role: 'annotation' }]);
    this.kpis.forEach((i) => {
      this.chartData.push([
        `${StringUtils.abbreviate(i.nome, 25)}`,
        Math.ceil((i.tempoTotalMinutos / 60) * 10) / 10,
        Math.ceil((i.tempoTotalMinutos / 60) * 10) / 10
      ]);
    });
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }
}
